import { render, staticRenderFns } from "./BAI.vue?vue&type=template&id=46df42b4&scoped=true&"
import script from "./BAI.vue?vue&type=script&lang=js&"
export * from "./BAI.vue?vue&type=script&lang=js&"
import style0 from "./BAI.vue?vue&type=style&index=0&id=46df42b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46df42b4",
  null
  
)

export default component.exports